import styled from 'styled-components';
import { Select } from '@perch-labs/shrike';

export const StyledSelect = styled(Select)`
  max-width: none;
`;
